import React from 'react';
import i18n from 'i18next';

export const DrawerContext = React.createContext();
DrawerContext.displayName = i18n.t('context.drawer.drawerContextProvider');

export const DrawerProvider = DrawerContext.Provider;
